import { OmitType, PartialType } from '../../../utils';
import { CreateD2CDiscountCodeDto } from './create-d2c-discount-code.dto';
export class UpdateD2CDiscountCodeDto extends PartialType(OmitType(CreateD2CDiscountCodeDto, ['isCompanyIssued'])) {
}
